import React from 'react';

import d2d from '@assets/img/icons/d2d-black.png';
import { makeMuiStyles, useCommonStyles } from '@styles';

const useStyles = makeMuiStyles((theme, common) => ({
  container: {
    maxWidth: 1200,
    margin: '0 auto',
  },
  wrapper: {
    padding: '1rem',
    paddingTop: '4rem',
    paddingBottom: '8rem',
  },
  title: {
    ...common.flexInline,
    ...common.itemsCenter,
    ...common.largeText,
    columnGap: '1rem',
    marginBottom: '1rem',
    [theme.breakpoints.down('sm')]: {
      ...common.largeText,
      paddingLeft: 0,
    },
  },
  subtitle: {
    ...common.flexInline,
    ...common.itemsCenter,
    ...common.justifyBetween,
    ...common.middleText,
    ...common.textGray800,
    padding: '1rem 0',
  },
}));

export interface NewPageContainerProps {
  title: string;
  subtitle: string;
  action?: React.ReactNode;
  maxWidth?: number;
}

export const NewPageContainer: React.FC<React.PropsWithChildren<NewPageContainerProps>> = (
  props,
) => {
  const { title, subtitle, children, action = null, maxWidth } = props;

  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  return (
    <div className={classes.wrapper}>
      <div className={classes.container} style={{ maxWidth }}>
        <div className={classes.title}>
          <img src={d2d} alt="D2D Logo" width={100} height={23} />
          <span>{title}</span>
        </div>

        <div className={classes.subtitle}>
          {subtitle}
          {action}
        </div>

        {children}
      </div>
    </div>
  );
};
